import { useApiClient } from '../client.js'

export const GET_USER_BUSINESSES_ENDPOINT = '/core/v2/business_api/me/businesses'

export function getUserBusinesses () {
  const apiClient = useApiClient()

  return apiClient.get({
    url: GET_USER_BUSINESSES_ENDPOINT,
  })
}
